// reducer.js
import {
  SERVICE_SETTINGS_FETCH_ACTION,
  SERVICE_SETTINGS_FETCH_SUCCESS,
  SERVICE_SETTINGS_FETCH_ERROR,
  SERVICE_SETTINGS_SAVE_ACTION,
  SERVICE_SETTINGS_SAVE_SUCCESS,
  SERVICE_SETTINGS_SAVE_ERROR
} from "./actionType";

const INIT_STATE = {
  ServiceSettingData: [],
  fetchLoading: false,
  saveLoading: false,
  saveResponse: {},
};

const ServiceSettingsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SERVICE_SETTINGS_FETCH_ACTION:
      return { ...state, fetchLoading: true };

    case SERVICE_SETTINGS_FETCH_SUCCESS:
      return { ...state, ServiceSettingData: action.payload || [], fetchLoading: false };

    case SERVICE_SETTINGS_FETCH_ERROR:
      return { ...state, fetchLoading: false };

    case SERVICE_SETTINGS_SAVE_ACTION:
      return { ...state, 
        saveLoading: true 
        
      };

    case SERVICE_SETTINGS_SAVE_SUCCESS:
      return { ...state, saveLoading: false, saveResponse: action.payload  };

    case SERVICE_SETTINGS_SAVE_ERROR:
      return { ...state, saveLoading: false ,  saveResponse: action.payload };

    default:
      return state;
  }
};

export default ServiceSettingsReducer;
